export default (images = [], minPixelWidth) =>
  images && images.length
    ? (
        images
          .concat()
          .reverse()
          .find(
            ({ width }) =>
              width >= minPixelWidth * (global.devicePixelRatio || 1)
          ) || images[0]
      ).url
    : null;
